import normalizeComponent from "../../../_virtual/_plugin-vue2_normalizer.mjs";
const _sfc_main = {};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("svg", { attrs: { "width": "16", "height": "16", "viewBox": "0 0 16 16", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, [_c("path", { attrs: { "d": "M14.6666 3.33333L1.33331 3.33333L1.33331 2L14.6666 2V3.33333Z", "fill": "currentColor" } }), _c("path", { attrs: { "d": "M5.6673 8.66667H1.33331L1.33331 7.33333L5.6673 7.33333V8.66667Z", "fill": "currentColor" } }), _c("path", { attrs: { "d": "M1.33331 14H5.6673V12.6667H1.33331L1.33331 14Z", "fill": "currentColor" } }), _c("path", { attrs: { "d": "M10.4006 8.19987V10.9333H13.1333V9.73333H11.6006V8.19987H10.4006Z", "fill": "currentColor" } }), _c("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", "d": "M11.0006 14.6667C13.3939 14.6667 15.334 12.7266 15.334 10.3333C15.334 7.9401 13.3939 6 11.0006 6C8.6074 6 6.6673 7.9401 6.6673 10.3333C6.6673 12.7266 8.6074 14.6667 11.0006 14.6667ZM11.0006 13.3333C12.6575 13.3333 14.0006 11.9902 14.0006 10.3333C14.0006 8.67648 12.6575 7.33333 11.0006 7.33333C9.34378 7.33333 8.00063 8.67648 8.00063 10.3333C8.00063 11.9902 9.34378 13.3333 11.0006 13.3333Z", "fill": "currentColor" } })]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  null
);
const AITranscription = __component__.exports;
export {
  AITranscription as default
};
